module.exports = __webpack_public_path__ + "img/banner3.87ee577a.png";